import { Button } from 'antd';
import styled from 'styled-components';

export const StyledImageCardActionButton = styled(Button)`
  ${({ theme }) => `
    background: ${theme.Color.NeutralsFixed.Gray};
    &:hover {
      background: ${theme.Color.NeutralsFixed.Text} !important;
    };
    & .ant-btn-loading-icon {
        color: ${theme.Color.NeutralsFixed.Paper};
    };
  `}
`;
